// This file is generated automatically by `scripts/build/fp.ts`. Please, don't change it.

import { getHours as fn } from "../getHours.js";
import { convertToFP } from "./_lib/convertToFP.js";

export const getHours = convertToFP(fn, 1);

// Fallback for modularized imports:
export default getHours;
